// This file was generated and should not be edited
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var IconMedGlasses_1;
import { html } from 'lit';
import { customElement } from 'lit/decorators.js';
import { IconBaseElement } from '../base/icon-base.component';
const _s24IconSvg = html `<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path fill-rule="evenodd" clip-rule="evenodd" d="M6.5 15C7.88071 15 9 13.8807 9 12.5C9 11.1193 7.88071 10 6.5 10C5.11929 10 4 11.1193 4 12.5C4 13.8807 5.11929 15 6.5 15ZM6.5 17C8.98528 17 11 14.9853 11 12.5C11 12.4607 10.9995 12.4215 10.9985 12.3824C11.5644 11.8724 12.4356 11.8724 13.0015 12.3824C13.0005 12.4215 13 12.4607 13 12.5C13 14.9853 15.0147 17 17.5 17C19.8163 17 21.7238 15.25 21.9725 13H24V11H21.7439C21.1262 9.25221 19.4593 8 17.5 8C15.7911 8 14.3048 8.95252 13.5428 10.3556C12.574 9.88135 11.426 9.88134 10.4572 10.3556C9.69522 8.95251 8.20885 8 6.5 8C4.54067 8 2.87381 9.25221 2.25606 11H0V13H2.02746C2.27619 15.25 4.18372 17 6.5 17ZM17.5 15C18.8807 15 20 13.8807 20 12.5C20 11.1193 18.8807 10 17.5 10C16.1193 10 15 11.1193 15 12.5C15 13.8807 16.1193 15 17.5 15Z" class="svg-bg"/>
</svg>
`;
/**
 * IconMedGlasses is a generated icon component.
 */
let IconMedGlasses = IconMedGlasses_1 = class IconMedGlasses extends IconBaseElement {
    render() {
        return html `${IconMedGlasses_1.icons.get(this.size)}`;
    }
};
/**
   * Defines which icon resource to use at which icon size
   */
IconMedGlasses.icons = new Map([
    ['s8', _s24IconSvg],
    ['s12', _s24IconSvg],
    ['s16', _s24IconSvg],
    ['s24', _s24IconSvg],
    ['s32', _s24IconSvg],
    ['s40', _s24IconSvg],
    ['s48', _s24IconSvg],
    ['s64', _s24IconSvg],
    ['s72', _s24IconSvg],
    ['s80', _s24IconSvg],
]);
IconMedGlasses = IconMedGlasses_1 = __decorate([
    customElement('zui-icon-med-glasses')
], IconMedGlasses);
export { IconMedGlasses };
